
import { throwError as observableThrowError, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators'
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { AcepSSOService } from '@acepteam/globalspack';


@Injectable()
export class AcepHttpInterceptor implements HttpInterceptor {
    private count: number = 0;

    constructor(public ssoSvc: AcepSSOService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // 1. SHOW SPINNER

        let headers = req.headers;

        this.count++;
        //do not show loader for calls that are meant to be silently run..eg: check for exisitng npi, username etc..
        if (this.count == 1 && !headers.has('x-silent')) this.ssoSvc.showwait();

        //console.info(`Http Interceptor Url`, req.url);

        // 2. H E A D E R S


        //if headers are already present do not update
        if (!headers.has('Content-Type')) {
            headers = new HttpHeaders({
                'Authorization': `Bearer ${this.ssoSvc.acepJWTToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'PUT, GET, POST',
                'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
            })
        }

        // const headers = req.headers
        //     .set('Content-Type', 'application/json');



        // 3. CHECK JWT AUTHENTICATION

        //if this header is present, then do not check for JWT Authentication OR making call to get JWT
        if (!headers.has("x-noauth") && req.url.toLowerCase().indexOf('getcontext') == -1 && this.ssoSvc.isUserLoginExpired()) {
            this.ssoSvc.login();
            return of(null);
        }


        const authReq = req.clone({ headers });

        let handleObs: Observable<HttpEvent<any>> = next.handle(authReq);

        return handleObs.pipe(catchError((err: any) => {
            return observableThrowError(err);
        }),
            tap((event: HttpEvent<any>) => {

                if (event instanceof HttpResponse) {
                    this.count--;
                    // do stuff with response if you want
                }
            }, (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    this.count--;
                    if (err.status === 401) {
                        // redirect to the login route
                        // or show a modal
                        this.ssoSvc.login();
                    }
                    else {
                        if (this.count == 0) this.ssoSvc.hidewait();
                    }
                }
            }, () => {
                if (this.count == 0) this.ssoSvc.hidewait();
            })
        )

    }
}